import React from 'react';
import {ApolloProvider} from '@apollo/react-hooks';
import {Provider} from 'react-redux';
import {hot} from 'react-hot-loader/root';

import ListingPageContainer from './components/ListingPage/ListingPageContainer';
import MesoAdsContextProvider from './components/MesoAdsContext/MesoAdsContextProvider';
import IntlProviderWrapper from './components/IntlProviderWrapper/IntlProviderWrapper';

import {ExperimentProvider} from '@homeaway/react-experiment';
import {SkipToContentMenuProvider} from '@homeaway/react-skip-to-content-menu';
import {LocalizationContextProvider} from '@homeaway/react-localization-components';
import {SystemContextProvider} from '@homeaway/catalyst-globalization-configuration';

function Root({client, store, listingPageComponent, siteContext, router: Router}) {
    const {
        abacusTestsReducer: abacus,
        translationsReducer: {
            skipMenuListAreaLabel: skipToContentLabel,
            skipMenuShortCutInstruction: skipToContentShortCut
        }
    } = store.getState();

    return (
        <ApolloProvider client={client}>
            <Provider store={store}>
                <IntlProviderWrapper>
                    <ExperimentProvider abacus={abacus}>
                        <SystemContextProvider context={siteContext}>
                            <LocalizationContextProvider siteContext={siteContext}>
                                <SkipToContentMenuProvider
                                    menuTitle={skipToContentShortCut}
                                    ariaLabel={skipToContentLabel}
                                >
                                    <MesoAdsContextProvider>
                                        <Router>
                                            <ListingPageContainer
                                                listingPageComponent={listingPageComponent}
                                            />
                                        </Router>
                                    </MesoAdsContextProvider>
                                </SkipToContentMenuProvider>
                            </LocalizationContextProvider>
                        </SystemContextProvider>
                    </ExperimentProvider>
                </IntlProviderWrapper>
            </Provider>
        </ApolloProvider>
    );
}

export default hot(Root);
